import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { FileText, BarChart3, History, LogOut, Wallet } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/', label: 'Invoice Generator', icon: FileText },
    { path: '/analytics', label: 'Analytics', icon: BarChart3 },
    { path: '/expenses', label: 'Expenses', icon: Wallet },
    { path: '/invoices', label: 'Invoice History', icon: History },
  ];

  return (
    <div className="min-h-screen bg-[#FFFBF5]">
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="text-center flex-1">
              <h1 className="text-3xl font-extrabold text-[#7FA1C3]" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Convella
              </h1>
              <p className="text-sm text-[#6B7280] font-medium" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                The Taste of Real Ice Cream
              </p>
            </div>
            <div className="flex items-center gap-4">
              {user && (
                <>
                  <span className="text-sm text-slate-600">Welcome, <strong>{user.username}</strong></span>
                  <Button
                    onClick={handleLogout}
                    className="bg-red-500 hover:bg-red-600 text-white rounded-full px-4 py-2"
                  >
                    <LogOut size={16} className="mr-2" />
                    Logout
                  </Button>
                </>
              )}
            </div>
          </div>
          <nav className="flex items-center justify-center space-x-1 pb-4">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className={`flex items-center gap-2 px-6 py-2.5 rounded-full font-semibold transition-all ${
                    isActive
                      ? 'bg-[#7FA1C3] text-white shadow-md'
                      : 'text-[#6B7280] hover:bg-[#7FA1C3]/10 hover:text-[#7FA1C3]'
                  }`}
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  <Icon size={18} />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}